(function() {
  window.adConfigs = window.adConfigs || {};

  const habits = {
    'coffee':        'For your coffee moment',
    'tv':            'For nights like this',
    'bedside-table': 'For your bedside',
    'sofa':          'This is the plan',
    'after-dinner':  'For after dinner',
  };

  const habitSocialProof = {
    'coffee':        '★★★★★ Perfect with a coffee',
    'tv':            '★★★★★ Didn\'t last through the episode',
    'bedside-table': '★★★★★ I never share these',
    'sofa':          '★★★★★ Absolutely unreal bars',
    'after-dinner':  '★★★★★ Didn\'t make it past dessert',
  };

  const habitImages = {
    'coffee': {
      'caramel':      null,
      'peanutbutter': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Coffee-peanutbutter-habit.png?v=1776936757',
      'pistachio':    null,
      'raspberry':    null,
      'pretzel':      'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Habit-Coffee-Hazelnut-PDP.png?v=1775637624',
      'smaltz':       null,
    },
    'tv': {
      'caramel':      null,
      'peanutbutter': null,
      'pistachio':    null,
      'raspberry':    'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Raspberry_TV_habit.png?v=1776357316',
      'pretzel':      'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Habit-TVNoisey-PDP.png?v=1775742716',
      'smaltz':       null,
    },
    'bedside-table': {
      'caramel':      'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Habit-BedsideTable-Caramel.png?v=1775665704',
      'peanutbutter': null,
      'pistachio':    null,
      'raspberry':    'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Raspberry_bedside_habit_shopify.png?v=1776345023',
      'pretzel':      null,
      'smaltz':       null,
    },
    'sofa': {
      'caramel':      null,
      'peanutbutter': null,
      'pistachio':    null,
      'raspberry':    null,
      'pretzel':      null,
      'smaltz':       null,
    },
    'after-dinner': {
      'caramel':      'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Screenshot_2026-04-10_at_17.37.56.png?v=1775839085',
      'peanutbutter': null,
      'pistachio':    null,
      'raspberry':    null,
      'pretzel':      null,
      'smaltz':       null,
      'ontablewithlamp': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Barney_goff_Move_the_bar_that_says_rascal_on_it_slightly_towards_the_bar_that_2698e6f7-099d-40a5-840f-6da4399ec95e.png?v=1777557570',
    },
  };

  const flavourKeys = {
    'caramel':      'Caramel',
    'peanutbutter': 'Peanut Butter',
    'pistachio':    'Pistachio',
    'raspberry':    'Raspberry',
    'pretzel':      'Hazelnut',
    'smaltz':       'Malt Cornflakes',
    'ontablewithlamp': 'Caramel',
  };

  Object.entries(habits).forEach(([habit, subtitle]) => {
    Object.entries(flavourKeys).forEach(([flavourKey, flavourLabel]) => {
      const key = `habit-bab-${habit}-${flavourKey}`;
      const pdpImage = habitImages[habit][flavourKey];
      const socialProof = habitSocialProof[habit];

// Version A — box in cart (no cartImage)
      window.adConfigs[key] = {
        subtitle,
        heroImage:  pdpImage,
        cartImage:  null,
        socialProof,
        flavour:    flavourLabel,
      };

    });
  });
})();